import { IconProps } from 'types/icon.type'

export const SearchIcon = (props: IconProps) => {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Search icon</title>
      <mask
        id="mask0_2_150"
        maskUnits="userSpaceOnUse"
        x="-2"
        y="0"
        width="38"
        height="39"
      >
        <rect
          x="-1.88574"
          y="0.503021"
          width="37.635"
          height="37.635"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_2_150)">
        <path
          d="M12.9594 25.3578C10.1253 25.3578 7.72657 24.3755 5.76327 22.4109C3.80024 20.4466 2.81873 18.0661 2.81873 15.2697C2.81873 12.4732 3.80103 10.0926 5.76563 8.12802C7.72996 6.16342 10.1148 5.18112 12.9202 5.18112C15.7253 5.18112 18.1057 6.16342 20.0614 8.12802C22.0174 10.0926 22.9954 12.4745 22.9954 15.2736C22.9954 16.4034 22.8125 17.4867 22.4466 18.5235C22.0807 19.56 21.5492 20.514 20.8522 21.3853L30.1041 30.5848C30.3568 30.8296 30.4832 31.1414 30.4832 31.5201C30.4832 31.8986 30.3568 32.214 30.1041 32.4665C29.8514 32.7192 29.5358 32.8456 29.1574 32.8456C28.7789 32.8456 28.4672 32.7192 28.2224 32.4665L18.9967 23.2408C18.2126 23.9028 17.3026 24.4212 16.2666 24.796C15.2306 25.1705 14.1282 25.3578 12.9594 25.3578ZM12.9331 22.7441C15.0023 22.7441 16.7609 22.0146 18.2091 20.5554C19.6575 19.0963 20.3817 17.3344 20.3817 15.2697C20.3817 13.205 19.6575 11.4429 18.2091 9.98351C16.7609 8.52437 15.0023 7.79479 12.9331 7.79479C10.8496 7.79479 9.07855 8.52437 7.61993 9.98351C6.16158 11.4429 5.4324 13.205 5.4324 15.2697C5.4324 17.3344 6.16158 19.0963 7.61993 20.5554C9.07855 22.0146 10.8496 22.7441 12.9331 22.7441Z"
          fill={props.color ?? '#1C1B1F'}
        />
      </g>
    </svg>
  )
}
